import axios from "axios";

const baseURL = process.env.VUE_APP_API_URL;

class AdminPanelService {
  static getAdminRequests({ search_text, request_status, page, page_size, export_file, order_by, sort }: any) {
    let url = `${baseURL}/charity/requests?page=${page}&page_size=${page_size}&search=${search_text}&request_status=${request_status}&export=${export_file}`;
    if (order_by) {
      url += `&order_by=${order_by}&sort=${sort}`;
    }

    return axios.get(url);
  }
  static getAcceptedCharities({ search_text, request_status,activity_status, page, page_size, export_file, order_by, sort }: any) {
    let url = `${baseURL}/charity/requests/accepted-charities?page=${page}&page_size=${page_size}&search=${search_text}&request_status=${request_status}&activity_status=${activity_status}&export=${export_file}`;
    if (order_by) {
      url += `&order_by=${order_by}&sort=${sort}`;
    }

    return axios.get(url);
  }
  static updateChartityStatus(id: any) {
    let url = `${baseURL}/charity/request/${id}/deactivate/`;
    return axios.patch(url);
  }
  static getAdminRequestDetail(id: any) {
    let url = `${baseURL}/charity/request/${id}/`;

    return axios.get(url);
  }

  static getAdminRequestHistory(id: any) {
    let url = `${baseURL}/charity/request/${id}/history/`;

    return axios.get(url);
  }

  static getAdminRequestAgreements(id: any) {
    let url = `${baseURL}/charity/request/${id}/agreements/`;

    return axios.get(url);
  }

  static generateAdminRequestAgreement(id: any, data: any) {
    let url = `${baseURL}/charity/request/${id}/generate-agreement/`;

    return axios.patch(url, data);
  }

  static patchAdminRequestDetail(id: any, data: any) {
    let url = `${baseURL}/charity/request/${id}/`;

    return axios.patch(url, data);
  }

  // Charity request limits live on the Charity itself, not on its request row,
  // so this one takes the charity id (`charity_id` on the listing row).
  static updateCharityLimits(charityId: any, data: any) {
    let url = `${baseURL}/charity/${charityId}/limits`;

    return axios.patch(url, data);
  }

  static initialApprovalAdminRequestDetail(id: any, data: any) {
    let url = `${baseURL}/charity/request/${id}/initial-approval/`;

    return axios.patch(url, data);
  }

  static approveAdminRequestDetail(id: any, data: any) {
    let url = `${baseURL}/charity/request/${id}/approve/`;

    return axios.patch(url, data);
  }

  static rejectAdminRequestDetail(id: any, data: any) {
    let url = `${baseURL}/charity/request/${id}/reject/`;

    return axios.patch(url, data);
  }

  static getAdminMenu() {
    let url = `${baseURL}/charity/cases/component/sidebar/`;

    return axios.get(url);
  }

  static getTreatmentRequestsSubMenu() {
    let url = `${baseURL}/charity/treatment-request/sidebar/`;

    return axios.get(url);
  }

  static getSupportTicketsSubMenu() {
    let url = `${baseURL}/support-tickets-sidebar/`;

    return axios.get(url);   
  }
  static getCharityRequestsSubMenu() {
    let url = `${baseURL}/charity/request/sidebar/`;

    return axios.get(url);
  }
  static getWalletsSubMenu() {
    let url = `${baseURL}/wallet/sidebar`;

    return axios.get(url);
  }
  static getFinancialOperationsSubMenu() {
    let url = `${baseURL}/wallet/financial-operations-sidebar`;

    return axios.get(url);
  }
  static validateIBAN(requestID: number, iban: number) {
    let url = `${baseURL}/charity/request/${requestID}/validate-iban/`;

    return axios.patch(url, {iban});
  }

  static getUserMenuItems() {
    let url = `${baseURL}/account/menu-items`;
    
    return axios.get(url);
  }

  static charityDashboard() {
    let url = `${baseURL}/charity/dashboard`;

    return axios.get(url);
  }

  static adminDashboard() {
    let url = `${baseURL}/dashboard`;

    return axios.get(url);
  }

  static getDonorStatistics() {
    let url = `${baseURL}/wallet/donor-statistics/`;

    return axios.get(url);
  }

  static handleCharityUpdateRequest(payload: any) {
    let url = `${baseURL}/charity/request/update/action`;

    return axios.patch(url, payload);
  }

  static getAuditLogs({page_number,page_size, ordering, search, start_date, end_date, export_file,action,description,user_type,user_id,charity}: any) {
    
    let url = `${baseURL}/audit/user-audit-log?page_number=${page_number}&page_size=${page_size}`;
    if(ordering)
      url+=`&ordering=${ordering}`
    if(search && !user_id)
      url+=`&search=${search}`
    if(start_date)
      url+=`&start_date=${start_date}`
    if(end_date)
      url+=`&end_date=${end_date}`
    if(export_file) {
      url += `&export=${export_file}`;
    }
    if(action)
      url+=`&action=${action}`
    if(description)
      url+=`&description=${description}`
    if(user_type)
      url+=`&user_type=${user_type}`
    if(user_id)
      url+=`&user_id=${user_id}`
    if(charity)
      url+=`&charity=${charity}`
    return axios.get(url);

  }

  static getAuditLogsDropdown() {
    let url = `${baseURL}/audit/user-audit-log-dropdown/`;
    
    return axios.get(url);
  }

  static getUsersReportSidebar() {
    let url = `${baseURL}/users-report-sidebar/`;

    return axios.get(url);
  }

  static getCasesReportSidebar() {
    let url = `${baseURL}/cases-report-sidebar/`;

    return axios.get(url);
  }

  static getDonationsReportSidebar() {
    let url = `${baseURL}/donations-report-sidebar/`;

    return axios.get(url);
  }

  static getNestedReportSidebar() {
    let url = `${baseURL}/reports/nested-sub-items/sidebar/`;

    return axios.get(url);
  }
}

export default AdminPanelService;
